// extracted by mini-css-extract-plugin
export default {"listContainer":"List_listContainer__GeM4i","listItem":"List_listItem__I3w5c","rating":"List_rating__PvIBf"};